// Premium refunds and transfers can wait for a second person's approval
// (product flags refund_maker_checker / transfer_maker_checker). These helpers
// read what the engine answers in that case.

var CODE_MESSAGES = {
  APPROVAL_ALREADY_PENDING:
    'A refund, release or transfer for this premium is already waiting for approval or in progress. Decide or finish that one first.',
  TRANSFER_ALREADY_PENDING:
    'A transfer for this payment is already waiting for approval or in progress. Decide or finish that one first.',
  TRANSFER_PAYMENT_ALREADY_TRANSFERRED:
    'This payment has already been transferred.',
  TRANSFER_PAYMENT_PREMIUM_REVERSED:
    'This payment’s premium has been reversed, so it can’t be transferred.',
  APPROVAL_STALE:
    'The policy changed after this was requested, so nothing was done. Ask again from the current state.',
  APPROVAL_ALREADY_DECIDED: 'Someone else has already decided this request.',
}

// The engine answers 202 with status PENDING_APPROVAL: nothing has happened
// yet. The body also says refund_initiated_successfully: false, so check this
// before reading any refund_* field.
export function isPendingApproval(data) {
  return !!data && data.status === 'PENDING_APPROVAL'
}

export function pendingApprovalMessage(data, what) {
  var guid = data && data.approval_request_guid
  var ref = guid ? ' (request ' + String(guid).slice(0, 8) + ')' : ''
  return (
    'Sent for approval' +
    ref +
    '. The ' +
    (what || 'refund') +
    ' is made once a second person approves it.'
  )
}

// A refusal in plain language: the engine's code, else its own message, else a
// line for the statuses it uses for these actions, else `fallback`.
export function approvalErrorMessage(e, fallback) {
  var res = e && e.response
  var data = res && res.data
  var code = data && typeof data === 'object' ? data.code : undefined
  if (code && CODE_MESSAGES[code]) return CODE_MESSAGES[code]
  var text = typeof data === 'string' ? data : data && data.message
  if (text) return text
  if (res && res.status === 503) {
    return 'The product or the customer’s contact details couldn’t be read, so nothing was done. Try again shortly.'
  }
  if (res && res.status === 403) {
    return 'You can’t do this: you may lack permission, or you made this request yourself and a second person must decide it.'
  }
  return fallback
}

// With transfer_maker_checker off the engine executes a new transfer at once.
export function transferSubmittedMessage(data) {
  return data && data.status === 'Executed'
    ? 'Transfer carried out.'
    : 'Transfer submitted for approval. A second person must approve before it executes.'
}

// Money moved but the transfer was not completed: an Approved request whose
// reference starts INCOMPLETE- or UNFINALISED- needs a person to finish it.
export function transferNeedsFollowUp(transfer) {
  return (
    !!transfer &&
    transfer.status === 'Approved' &&
    /^(INCOMPLETE|UNFINALISED)-/.test(transfer.transfer_reference || '')
  )
}
